import { createSelector } from 'reselect';
import Immutable from 'immutable';
import { selectCurrentLibrary } from './LibrarySelector';

export const allSites = state => state.getIn(['entities', 'sites']);

const selectDefaultScopeId = createSelector(selectCurrentLibrary, allSites, (library, sites) => {
  return sites.getIn([library.get('siteId').toString(), 'defaultScopeId']);
});

export const selectCurrentSiteScopes = createSelector(
  selectCurrentLibrary,
  selectDefaultScopeId,
  allSites,
  (library, defaultScopeId, sites) => {
    const scopes = sites.getIn([library.get('siteId').toString(), 'scopes'], Immutable.List());
    const isSearchScopesEnabled = library.get('scopeFacetEnabled', false);
    if (!isSearchScopesEnabled) {
      return scopes
        .filter(searchScope => {
          return searchScope.get('scopeId') === defaultScopeId;
        })
        .map(scope => {
          return scope.set('isDefault', true);
        });
    }

    const excludedSearchScopeIds = library.get('excludeSearchScopeIds', Immutable.List());

    return scopes
      .filter(searchScope => {
        return excludedSearchScopeIds.indexOf(searchScope.get('scopeId')) === -1;
      })
      .map(scope => {
        return scope.set('isDefault', scope.get('scopeId') === defaultScopeId);
      });
  }
);
